<h1 class="m-3">Agregar Artículo</h1>
<div class="px-3" *ngIf="copied_from">
	<div class="alert alert-success d-flex justify-content-between align-items-center">
		<span>
			Configuración copiada de <b>{{copied_from.item.name}}</b>{{copy_prices?' (con precios)':''}}
		</span>
		<button type="button" class="btn btn-secondary btn-sm" (click)="clearCopy()">Quitar</button>
	</div>
</div>
<div class="p-3">
	<form name="addNewItemEasy" (ngSubmit)="save($event)" ngNativeValidate>
		<div class="row">
			<div class="col-3 col-lg-2">
				<app-image-uploader [(image)]="item_info.item.image_id"></app-image-uploader>
			</div>
			<div class="col-9 col-lg-10">
				<label for="name">Nombre</label>
				<div class="input-group">
					<input type="text" class="form-control" placeholder="Nombre" [(ngModel)]="item_info.item.name" name="name" required>
					<button type="button" class="btn btn-secondary" (click)="showCopyItemModal()" title="Copiar la configuración de otro artículo">
						<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24"><path fill="currentColor" d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z"/></svg>
					</button>
				</div>
			</div>

			<div class="col-12 col-lg-4">
				<app-search-category (categoryId)="item_info.item.category_id = $event" [category_id]="selected_category_id" [selected_category_name]="selected_category_name" [overflow_content]="false"></app-search-category>
			</div>

			<div class="col-12 col-lg-4">
				<label>
					<abbr title="Si el inventario necesita manejarse por lotes y/o tienen expiración">
						Inventario Con Lotes/expiracion
					</abbr>
				</label>
				<select class="form-control" name="batch_option" [(ngModel)]="item_info.item.batch_option">
					<option value="NONE">Ninguno</option>
					<option value="BATCH_AND_EXPIRATION">Con Lotes y Expiracion</option>
					<option value="BATCH_ONLY">SOLO lote</option>
					<option value="EXPIRATION_ONLY">Solo expiracion</option>
				</select>
			</div>

			<div class="col-12 col-lg-4">
				<label for="name">Código</label>
				<input type="text" class="form-control" placeholder="Código" [(ngModel)]="item_info.item.code" name="code" required>
			</div>
		</div>
		<div class="table-responsive my-3">
			<table class="table table-bordered">
				<thead>
					<tr class="table-light">
						<th>Lista</th>
						<th>Tipo</th>
						<th>Precio</th>
						<th>IVA</th>
						<th *ngIf="rest.local_preferences.currency_price_preference == 'MULTIPLE_CURRENCY'">Moneda</th>
					</tr>
				</thead>
				<tbody>
					<ng-container  *ngFor="let pl of price_list_list">
						<ng-container  *ngFor="let pt of price_type_list;let i=index">
							<tr>
								<td *ngIf="i==0" [rowSpan]="price_type_list.length" class="align-middle fw-bold">{{pl.name}}</td>
								<td>{{pt.name | titlecase}}</td>
								<td>
									<input type="number" class="form-control form-control-sm" [name]="'pprice_'+pl.id+'-'+pt.id" [(ngModel)]="price_dict[pl.id+'-'+pt.id].price" min="0" step="any" required>
								</td>
								<td>
									<select *ngIf="pt.tax_model=='ALL'" [name]="'tax_'+pl.id+'-'+pt.id" [(ngModel)]="price_dict[ pl.id+'-'+pt.id ].tax_included" class="form-select form-select-sm" required>
										<option value="YES">IVA Incluido</option>
										<option value="NO">Más IVA</option>
									</select>
									<small *ngIf="pt.tax_model != 'ALL'" class="text-muted">{{pt.tax_model=='PLUS_TAX'?'Más IVA':'IVA Incluido'}}</small>
								</td>
								<td *ngIf="rest.local_preferences.currency_price_preference == 'MULTIPLE_CURRENCY'">
									<input type="text" class="form-control form-control-sm" min="0" step="any" list="tipo_precio" minlength="3" maxlength="3" [name]="pl.id+'-'+pt.id" [(ngModel)]="price_dict[ pl.id+'-'+pt.id ].currency_id" placeholder="MXN" required>
								</td>
							</tr>
						</ng-container>
					</ng-container>
				</tbody>
			</table>
		</div>

		<div class="text-end">
			<button type="submit" class="btn btn-primary">Guardar</button>
		</div>
	</form>
</div>

<app-modal [(show)]="show_copy_item">
	<div class="p-3" style="min-width:min(90vw,600px)">
		<h4>Copiar configuración de otro artículo</h4>
		<p class="text-muted">
			Se copia la configuración completa (categoría, clave SAT, unidad de medida, impuestos, etc.) excepto el nombre y el código.
		</p>
		<div class="row">
			<div class="col-12">
				<label>Artículo</label>
				<app-search-items
					[(search_str)]="copy_search_str"
					[display_only_on_stock]="false"
					[reset_on_search]="false"
					(item_selected)="onCopyItemSelected($event)"></app-search-items>
			</div>
			<div class="col-12 mt-3">
				<div class="form-check">
					<input type="checkbox" class="form-check-input" id="copy_prices_check" [(ngModel)]="copy_prices" [ngModelOptions]="{standalone:true}">
					<label class="form-check-label" for="copy_prices_check">Copiar también los precios</label>
				</div>
			</div>
		</div>
		<div class="text-end mt-3">
			<button type="button" class="btn btn-secondary" (click)="show_copy_item = false">Cancelar</button>
		</div>
	</div>
</app-modal>
